<section class="md-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="md-list-shell">
    <div class="flex align-items-center justify-content-between mb-3">
      <h2 class="m-0">Business</h2>
      <div class="flex gap-2">
        <p-button
          label="New Business"
          icon="pi pi-plus"
          (onClick)="createBusiness()"
        ></p-button>
        <p-button
          label="Export"
          icon="pi pi-file-excel"
          styleClass="p-button-help"
          (click)="exportExcel()"
        ></p-button>
      </div>
    </div>

    <div class="mb-4 p-4 border-round-2xl bg-gray-100">
      <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
        <div class="grid formgrid p-fluid">
          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-building"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="businessName" id="businessNameFilter" class="w-full" />
                <label for="businessNameFilter">Business Name</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="businessCode" id="businessCodeFilter" class="w-full" />
                <label for="businessCodeFilter">Business Code</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <app-entity-dropdown-picker
            formControlName="businessUnit"
            [adapter]="businessUnitPickerAdapter"
            inputId="businessUnitFilter"
            label="Business Unit"
            placeholder="Any business unit"
            filterPlaceholder="Filter business units"
            columnClass="col-12 md:col-6 lg:col-4"
            addonIconClass="pi pi-sitemap"
          ></app-entity-dropdown-picker>
        </div>

        <div class="flex justify-content-end gap-2 mt-4">
          <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary" type="button" (onClick)="onReset()"></p-button>
          <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
        </div>
      </form>
    </div>

    <p-table
      #dt
      [value]="business"
      [rows]="10"
      [paginator]="true"
      [totalRecords]="totalRecords"
      [loading]="isLoading"
      [lazy]="true"
      (onLazyLoad)="loadBusinesss($event)"
      dataKey="id"
      styleClass="p-datatable-striped md-data-table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="businessName">
            Business Name <p-sortIcon field="businessName"></p-sortIcon>
          </th>
          <th pSortableColumn="businessCode">
            Business Code <p-sortIcon field="businessCode"></p-sortIcon>
          </th>
          <th>Business Unit</th>
           <th>AR Account</th>
          <th>AP Account</th>
          <th>Reference</th>
          <th style="width: 10rem">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-business>
        <tr>
          <td>{{ business.businessName }}</td>
          <td>{{ business.businessCode ?? null }}</td>
          <td>{{ business.businessUnitObject?.businessUnitName ?? business.businessUnitId ?? '-' }}</td>
           <td>{{ business.arAccount ?? null }}</td>
          <td>{{ business.apAccount ?? null }}</td>
          <td>{{ business.reference ?? null }}</td>
          <td>
            <div class="flex gap-2">
              <p-button
                icon="pi pi-pencil"
                styleClass="p-button-rounded p-button-success"
                (onClick)="editBusiness(business.id)"
              ></p-button>
              <p-button
                icon="pi pi-trash"
                styleClass="p-button-rounded p-button-danger"
                (onClick)="deleteBusiness(business.id)"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">No Business found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
